import React from 'react';
import { connect } from 'react-redux';
import { compose, withHandlers, branch, renderComponent, withState, lifecycle } from 'recompose';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import History from '@material-ui/icons/History';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import avatar from '../assets/avatar.jpg';

import {
  learnerVersionsRequest,
  printReportRequest,
  resetLearnerVersion,
} from '../redux/reducers/savedVersions';
import {selectUserThinkTool, selectUser, selectUserModule, selectRollout} from '../redux/reducers/userProgramsFull';
import * as moment from 'moment';

import Spinner from './Spinner';
import { commonStyles } from '../styles/styles';
import iconPrint from '../assets/icon_print.svg';
import { convertTime } from '../utils';
import IframePopup from './Popups/IframePopup';
import {getUsersForProgram, selectedProgram, getPrograms, getProgramsForCoach, getThinkToolsForUser, getCoachesPrograms} from '../redux/selectors'

import { MDBCard, 
  MDBCardBody, 
  MDBCardTitle, 
  MDBCardText, 
  MDBCardHeader, 
  MDBBtn, 
  MDBContainer, 
  MDBTabPane, 
  MDBTabContent, 
  MDBNav, 
  MDBNavItem, 
  MDBNavLink, 
  MDBDropdown,
  MDBDropdownItem,
  MDBDropdownToggle,
  MDBDropdownMenu,
  MDBRow,
  MDBCol,
  MDBIcon,
  MDBBadge} from "mdbreact";
import { STORAGE_LINK } from '../constants';



const CoachThinkToolList = ({
  classes,
  savedVersions,
  handlePrint,
  handleClickThinktool,
  handlePopupToggle,
  isShowPopup,
  thinktools,
  programs
}) => {
  

  const getButtonAction = (action, item) => {
    var btn = null
    switch (action) {
      case 'draft':
        btn = <MDBBtn className="table-btn noShadow" size="sm" color="warning"  onClick={() => handleClickThinktool(item)}>RESTORE</MDBBtn>
        break;
      case 'Reviewed':
        btn = <MDBBtn className="table-btn noShadow" size="sm" color="success"  onClick={() => handleClickThinktool(item)}>VIEW</MDBBtn>
        break;
      case 'Pending':
        btn = <MDBBtn className="table-btn noShadow" size="sm" color="danger-dark" onClick={() => handleClickThinktool(item)}>VIEW</MDBBtn>
        break;
      case 'completed':
        btn = <MDBBtn className="table-btn noShadow" size="sm" color="info">SHARE WITH COACH</MDBBtn>
        break;
      default:
        btn = null
        break;
    }
      // if(content.type!=='Assignments'){
      //   return false;
      // }else{
        return btn;
      //}
     
    };

    const getStatus = action => {
      var btn = null
      switch (action) {
        case 'draft':
          btn = <MDBBadge className="noShadow" style={{padding: 5, borderRadius:'0.25rem'}} color="warning-light">DRAFT</MDBBadge>
          break;
        case 'Reviewed':
          btn = <MDBBadge className="noShadow" style={{padding: 5, borderRadius:'0.25rem'}} color="success-light">REVIEWED</MDBBadge>
          break;
        case 'Pending':
          btn = <MDBBadge className="noShadow" style={{padding: 5, borderRadius:'0.25rem'}} color="danger-light">PENDING</MDBBadge>
          break;
        case 'completed':
          btn = <MDBBadge className="noShadow" style={{padding: 5, borderRadius:'0.25rem'}} color="info-light">COMPLETED</MDBBadge>
          break;
        default:
          btn = null
          break;
      }
        // if(content.type!=='Assignments'){
        //   return false;
        // }else{
          return btn;
        //}
       
      };
  if (thinktools) {
    const renderVersions = (item) => {
      return (
        
        <MDBRow className="table-row w-100 small-copy" style={{width:'100%', margin: '0 auto'}}>
          <MDBCol className="table-col pl-2 leftAlign col-3"> 
            <div style={{position: 'relative',float:'left', width:'29%'}}>
                {item.backgroundImg ? <img src={STORAGE_LINK+item.backgroundImg} className="rounded-circle z-depth-0"
                  style={{ border: '6px solid rgba(0, 0, 0, .25)', height: "45px",width: "45px",  marginRight: 10, zIndex: 1, top: -5}} alt="" />
              : <img src={avatar} className="rounded-circle z-depth-0"
              style={{ border: '6px solid rgba(0, 0, 0, .25)', height: "45px",width: "45px",  marginRight: 10, zIndex: 1, top: -5}} alt="" />
                }
            </div><p style={{float:'right', width:'65%', paddingLeft: 10 + 'px !important'}}> {item.name}</p>
          </MDBCol>
          <MDBCol className="table-col"><div className="xs-copy-ptsans"><p>
            <MDBBadge style={{position:'static',marginRight: 5}} className="badge-lg-pill-round danger-color-border noShadow"  color="danger-color">{item.versions && item.versions.length}</MDBBadge></p></div> 
          </MDBCol>
          <MDBCol className="table-col"> 
            <div className="xs-copy-ptsans">
              <p>
                <MDBBadge style={{position:'static',marginRight: 5}} className="badge-lg-pill-round  noShadow"  color="badge-success-light">{item.tt_instancePending}</MDBBadge>
              </p>
            </div> 
          </MDBCol>
          <MDBCol className="table-col col-2"><p><MDBIcon className="pr-2" far icon="calendar" />{moment(item.updated_at.date).format('YYYY/MM/DD')}</p></MDBCol>
          {/* <MDBCol className="table-col"> 
            <p>
            <div className="mailBadge m-0" onClick={()=>this.props.showMessageCenter(true)}>
              <MDBIcon style={{fontSize: '1.3rem', color: '#3EAE69'}} far icon="envelope" className="ml-1" size="lg" />
              <MDBBadge style={{left: '55%'}}  className="badge-white badge-sm-pill-round">{item.messageCount}</MDBBadge>
            </div>
            </p>
          </MDBCol> */}
          <MDBCol className="table-col"><p>{getStatus(item.tt_status)}</p></MDBCol>
          <MDBCol className="col-2 table-col pr-2 no-border"><p>{getButtonAction(item.tt_status, item)}</p></MDBCol>
          </MDBRow>
          
      );
      };
      const renderVersionsMedium = (item) => {
      
        return (
         <MDBCard style={{minHeight:'auto'}}>
          <MDBRow className="table-row w-100 small-copy" style={{width:'100%', margin: '0 auto'}}>
              <MDBCol className="table-col pl-2 col-8 no-border">
              <div style={{position: 'relative', float:'left', width:'16%'}}>
                {item.backgroundImg ? <img src={STORAGE_LINK+item.backgroundImg} className="rounded-circle z-depth-0"
                    style={{ border: '6px solid rgba(0, 0, 0, .25)', height: "45px",width: "45px",  marginRight: 10, zIndex: 1, top: -5}} alt="" />
                : <img src={avatar} className="rounded-circle z-depth-0"
                style={{ border: '6px solid rgba(0, 0, 0, .25)', height: "45px",width: "45px",  marginRight: 10, zIndex: 1, top: -5}} alt="" />
                  }
                </div>
                <div className="pt-2 pb-2" style={{width:'83%', float:'right', paddingLeft: 10 + 'px !important'}}>
                  <b>  {item.name}</b>
                </div>
                <div style={{clear: 'both', marginBottom:10}}></div>
                <div style={{width:'50%', textAlign:'left', float:'left'}}>
                 <div style={{display:'inline-block'}} className="small-copy-ptsans">
                  <MDBBadge style={{position:'static',marginRight: 5}} className="badge-lg-pill-round danger-color-border "  color="danger-color">{item.versions && item.versions.length}</MDBBadge>
                  </div>
                  <div style={{display:'inline-block'}}  className="small-copy">Instances</div>
                </div>
                <div style={{width:'50%', textAlign:'left', float:'right'}}>
                  <div style={{display:'inline-block'}}  className="xs-copy-ptsans">
                  <MDBBadge style={{position:'static',marginRight: 5}} className="badge-lg-pill-round  noShadow"  color="badge-success-light">{item.tt_instancePending}</MDBBadge>
                  </div>
                  <div style={{display:'inline-block'}} className="small-copy">Pending</div>
                </div>
                <div style={{clear: 'both'}}></div>
                <div  style={{marginTop:10, float:'left', marginLeft:6}}>
                  <MDBIcon style={{paddingRight: 7}} far icon="calendar" />{moment(item.updated_at.date).format('YYYY/MM/DD')}
                </div>
              </MDBCol>
              <MDBCol className="table-col pl-2 no-border col-4">
                <div style={{float:'right', paddingLeft:10, marginTop:10}}>
                {getStatus(item.tt_status)}
                </div>
                <div style={{clear: 'both', marginBottom:15}}></div>

                {/* <div style={{width:'50%',textAlign:'left', float:'right'}}>
                  <div className="mailBadge mt-2 ml-0 mr-0 mb-0" onClick={()=>this.props.showMessageCenter(true)}>
                    <MDBIcon style={{fontSize: '1.3rem', color: '#3EAE69'}} far icon="envelope" className="ml-1" size="lg" />
                    <MDBBadge style={{left: '55%'}} className="badge-white badge-sm-pill-round">{item.messageCount}</MDBBadge>
                  </div>
                </div> */}
                
                <div style={{position:'absolute', right:0, bottom: 0, width:'100%', textAlign:'right'}}>
                {getButtonAction(item.tt_status, item)}
                </div>
              </MDBCol>
            </MDBRow>
        </MDBCard>
        );
        };
      const renderVersionsSmall = (item) => {
      
        return (
          <MDBCard style={{minHeight:'auto'}}>
            <MDBRow className="table-row w-100 small-copy" style={{width:'100%', margin: '0 auto'}}>
              <MDBCol className="table-col pl-2 col-12 no-border">
              <div style={{position: 'relative', float:'left', width:'16%'}}>
                {item.backgroundImg ? <img src={STORAGE_LINK+item.backgroundImg} className="rounded-circle z-depth-0"
                    style={{ border: '6px solid rgba(0, 0, 0, .25)', height: "45px",width: "45px",  marginRight: 10, zIndex: 1, top: -5}} alt="" />
                : <img src={avatar} className="rounded-circle z-depth-0"
                style={{ border: '6px solid rgba(0, 0, 0, .25)', height: "45px",width: "45px",  marginRight: 10, zIndex: 1, top: -5}} alt="" />
                  }
                </div>
                <div className="pt-2 pb-2 pl-2" style={{width:'83%', float:'right', paddingLeft: 10 + 'px !important'}}>
                  <b>  {item.name}</b>
                </div>
                <div style={{clear: 'both', marginBottom:10}}></div>
                <div style={{width:'50%', textAlign:'left', float:'left'}}>
                 <div style={{display:'inline-block'}} className="small-copy-ptsans">
                  <MDBBadge style={{position:'static',marginRight: 5}} className="badge-lg-pill-round danger-color-border "  color="danger-color">{item.versions && item.versions.length}</MDBBadge>
                  </div>
                  <div style={{display:'inline-block'}}  className="small-copy">Instances</div>
                </div>
                <div style={{width:'50%', textAlign:'left', float:'right'}}>
                  <div style={{display:'inline-block'}}  className="xs-copy-ptsans">
                  <MDBBadge style={{position:'static',marginRight: 5}} className="badge-lg-pill-round  noShadow"  color="badge-success-light">{item.tt_instancePending}</MDBBadge>
                  </div>
                  <div style={{display:'inline-block'}} className="small-copy">Pending</div>
                </div>
                <div style={{clear: 'both'}}></div>
                <div  style={{marginTop:10, float:'left', marginLeft:6}}>
                  <MDBIcon style={{paddingRight: 7}} far icon="calendar" />{moment(item.updated_at.date).format('YYYY/MM/DD')}
                </div>
              </MDBCol>
              <MDBCol className="table-col pl-2 no-border col-12">
                <div style={{float:'left', paddingLeft:10, marginTop:10}}>
                {getStatus(item.tt_status)}
                </div>

                {/* <div style={{width:'50%',textAlign:'left', float:'right'}}>
                  <div className="mailBadge mt-2 ml-0 mr-0 mb-0" onClick={()=>this.props.showMessageCenter(true)}>
                    <MDBIcon style={{fontSize: '1.3rem', color: '#3EAE69'}} far icon="envelope" className="ml-1" size="lg" />
                    <MDBBadge style={{left: '55%'}} className="badge-white badge-sm-pill-round">{item.messageCount}</MDBBadge>
                  </div>
                </div> */}
                
                <div style={{float:'right', width:'50%'}}>
                {getButtonAction(item.tt_status, item)}
                </div>
              </MDBCol>
            </MDBRow>
        </MDBCard>
        );
        };
    return (
     
      <div>
    <MDBCard  className="z-depth-2 rounded-0 d-none d-lg-block yellow-card" style={{height:"100%"}}>
    <div className='gothamBlack text-dark text-left pt-3 pl-3'>
      THINKTOOLS
    </div>
        
    <div style={{height:1, backgroundColor:'#CCCCCC', marginTop:12}}></div>
      <div style={{backgroundColor:'#ffffff'}}>
      <MDBRow className="w-100 pt-2 pb-2" style={{fontSize: '0.7rem',margin: '0 auto', backgroundColor:'#EBEBEB'}}>
          <MDBCol className="center col-3">Name</MDBCol>
          <MDBCol className="center">Instances</MDBCol>
          <MDBCol className="center">Pending</MDBCol>
          <MDBCol className="center col-2">Last Accessed</MDBCol>
          {/* <MDBCol className="center">Messages</MDBCol> */}
          <MDBCol className="center">Status</MDBCol>
          <MDBCol className="col-2 center col-2">Actions</MDBCol>
      </MDBRow>
      {thinktools && thinktools.map((item, idx) => (
      renderVersions(item)
      ))}
      </div>

</MDBCard>
<MDBCard  className="z-depth-2 rounded-0 d-none d-md-block d-lg-none yellow-card" style={{height:"100%"}}>
    <div className='gothamBlack text-dark text-left pt-3 pl-3'>
      THINKTOOLS
    </div>
    <div style={{height:1, backgroundColor:'#CCCCCC', marginTop:12}}></div>
    <div className="contentScrollList">
      {thinktools && thinktools.map((item, idx) => (
      renderVersionsMedium(item)
      ))}
      </div>

</MDBCard>

<MDBCard  className="z-depth-2 rounded-0  d-md-none yellow-card" style={{height:"100%"}}>
  <div className='gothamBlack text-dark text-left pt-3 pl-3'>
        THINKTOOLS
        </div>
        
    <div style={{height:1, backgroundColor:'#CCCCCC', marginTop:12}}></div>
    <div className="contentScrollList">
      {thinktools && thinktools.map((item, idx) => (
      renderVersionsSmall(item)
      ))}
      </div>

</MDBCard>
        {/* {savedVersions.learnerVersions.reverse().map((item, idx) => (
          <div className={classes.versionItem} key={idx.toString()}>
            <div className={classes.itemLeft}>
              <p className={classes.versionName}>{item.name}</p>
              <History className={classes.itemIcon} />
              <span className={classes.versionDate}>{convertTime(item.updated_at.date)}</span>
            </div>
            {item.progressPercentage && (
              <div className={classes.itemPercentage}>{`${item.progressPercentage}%`}</div>
            )}
            <div className={classes.itemRight}>
              <div className={classes.itemLink}>
                
                <img src={iconPrint} alt="print" onClick={() => handlePrint(item.versionId)} />
               
              </div>
              <Button
                className={`${classes.defaultButton} ${classes.buttonVersions}`}
                variant="raised"
                onClick={() => handleClickVersion(item.path, item.versionId)}
              >
                RESTORE
              </Button>
            </div>
          </div>
        ))} */}
        {isShowPopup &&
          savedVersions.versionsPdf && (
            <IframePopup
              handlePopupToggle={handlePopupToggle}
              pathToIframeFile={savedVersions.versionsPdf.path}
              selectedContentItem={{ type: 'Document' }}
              contentIframe={false}
            />
          )}
      </div>
    );
  }
  return <Typography className={classes.text}>{savedVersions.error}</Typography>;
};

const styles = () => ({
  ...commonStyles,
});

const mapStateToProps = state => ({
  versions: state.savedVersionsReducer,
  userProgramsFull: state.userProgramsFullReducer,
  programs: getCoachesPrograms(state),
  thinktools: getThinkToolsForUser(state),
  savedVersions: state.savedVersionsReducer,
});

const mapDispatchToProps = dispatch => ({
  printReportRequest: versionId => dispatch(printReportRequest(versionId)),
  selectUserThinktool: contentId => dispatch(selectUserThinkTool(contentId)),
  selectUserModule: contentId => dispatch(selectUserModule(contentId)),
  selectRollout: contentId => dispatch(selectRollout(contentId)),
  selectUser: userId => dispatch(selectUser(userId)),
  learnerVersionsRequest: () => dispatch(learnerVersionsRequest()),
  resetLearnerVersion: () => dispatch(resetLearnerVersion()),
});

export default compose(
   withRouter,
  withState('isShowPopup', 'togglePopup', false),
  withState('startTime', 'setStartTime', null),
  withState('stopTime', 'setStopTime', null),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withHandlers({
    handlePrint: props => value => {
      props.selectUserVersion(value);
      props.printReportRequest(value);
      props.togglePopup(true);
    },
    handlePopupToggle: props => () => {
      props.togglePopup(false);
    },
    handleClickThinktool: props => (item) => {
      props.selectUser(props.userProgramsFull.selectedUserId);
      props.selectUserThinktool(item.contentId);
      props.selectUserModule(item.module_id);
      props.selectRollout(item.rollout_id);
      props.history.push(
        `/users/${props.userProgramsFull.selectedProjectId}/${props.userProgramsFull.selectedRollout}/${props.userProgramsFull.selectedUserId}/${item.contentId}`+ props.history.location.search,
      );
    },
  }),
  lifecycle({
    componentWillMount() {
      
    },
  }),
  withStyles(styles),
)(CoachThinkToolList);

CoachThinkToolList.propTypes = {
  classes: PropTypes.instanceOf(Object),
  savedVersions: PropTypes.instanceOf(Object),
  handlePrint: PropTypes.func,
  handleClickVersion: PropTypes.func,
  handlePopupToggle: PropTypes.func,
  isShowPopup: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/Components/CoachThinkToolList.jsx